import { useAuthStore } from '@/store/authStore'
import { refreshAccessToken } from '@/services/authService'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5050/api'

let refreshingPromise: Promise<string | null> | null = null

// login/refresh_token ครั้งเดียวกันเสมอ แม้มีหลาย request 401 พร้อมกัน (กันยิง refresh-token ซ้ำ)
async function getFreshAccessToken(): Promise<string | null> {
  const { refreshToken, setAuth, clearAuth } = useAuthStore.getState()
  if (!refreshToken) return null

  if (!refreshingPromise) {
    refreshingPromise = refreshAccessToken(refreshToken)
      .then(({ access_token, refresh_token }) => {
        setAuth(access_token, refresh_token)
        return access_token
      })
      .catch(() => {
        clearAuth()
        return null
      })
      .finally(() => {
        refreshingPromise = null
      })
  }
  return refreshingPromise
}

// เรียก endpoint ที่ต้อง login (Authorization: Bearer) — token หมดอายุ (401) จะ refresh แล้ว retry ให้ 1 ครั้งอัตโนมัติ
export async function authFetch(path: string, options: RequestInit = {}): Promise<Response> {
  const accessToken = useAuthStore.getState().accessToken

  const withAuthHeader = (token: string | null) => ({
    ...options,
    headers: {
      // FormData ต้องให้ browser ตั้ง Content-Type (พร้อม boundary) เอง
      ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...options.headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  })

  let res = await fetch(`${API_URL}${path}`, withAuthHeader(accessToken))

  if (res.status === 401) {
    const newToken = await getFreshAccessToken()
    if (newToken) {
      res = await fetch(`${API_URL}${path}`, withAuthHeader(newToken))
    }
  }

  return res
}
